import { render, staticRenderFns } from "./editGeneralMeeting.vue?vue&type=template&id=4798f7da&scoped=true&"
import script from "./editGeneralMeeting.vue?vue&type=script&lang=js&"
export * from "./editGeneralMeeting.vue?vue&type=script&lang=js&"
import style0 from "./editGeneralMeeting.vue?vue&type=style&index=0&id=4798f7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798f7da",
  null
  
)

export default component.exports